<style type="less" scoped>
    @import url('./css.less');
</style>
<template>
    <div class="container">
        <BusinessEchartBmap v-on:map-load="mapLoad" v-bind="$props" ref='map'>
        </BusinessEchartBmap>
    </div>
</template>

<script>
    import BusinessEchartBmap from './../common/businessEchartBmap/index';
    import EffectScatter from './../common/echartOverlay/EffectScatter';
    import mapPropsMinxin from './default-props-value';
    import echarts from 'echarts';
    import defaultData from './data.json';

    // const data = [{
    //         "geometry": {
    //             "type": "Point",
    //             "coordinates": [116.54611555876909, 40.26940227400542]
    //         },
    //         name: "小区1",
    //         "count": 60
    //     },
    //     {
    //         "geometry": {
    //             "type": "Point",
    //             "coordinates": [116.53461724824012, 39.7175246792259]
    //         },
    //         name: "小区2",
    //         "count": 60
    //     }
    // ];
    export default {
        name: '',
        props: {
            dataJSON: {
                type: Array,
                default: function () {
                    return defaultData;
                }
            }
        },
        mixins: [mapPropsMinxin],
        components: {
            BusinessEchartBmap
        },
        data() {
            return {
                timer: null
            }
        },
        watch: {

        },
        computed: {

        },
        methods: {

            mapLoad() {
                const mapComponent = this.$refs.map.getMapComponent();
                let dt = [];
                const types = {
                    1: "确诊病例，严格封闭管理",
                    2: "疑似病例，出入严格管控",
                    3: "未发现病例,严格管控"
                }
                const tooltip = {
                    show: true,
                    formatter: function (params) {

                        const housing = dt.find((item) => {
                            return item.name == params.name;
                        });

                        if (housing) {
                            let message = `<b>${params.name}：</b><br/>`;
                            if (housing.count > 0) {
                                message += `当日来京人数: ${housing.count||"未知"}<br/>`;
                            }
                            message += `${types[housing._data['状态']]}`;
                            return message;
                        }
                    }
                };
                const makeScatter = new EffectScatter({
                    // brushType: "fill",
                    label: false,
                    // symbolSize: 15,
                    scale: 4.5,
                    tooltip: tooltip,

                });
                const suspectScatter = new EffectScatter({
                    // brushType: "fill",
                    color: "#ff9900",
                    scale: 4.5,
                    // symbolSize: 15,
                    label: false,
                    tooltip: tooltip

                });
                const normalScatter = new EffectScatter({
                    // brushType: "fill",
                    color: "#1DE9B6",
                    scale: 4.5,
                    // symbolSize: 15,
                    label: false,
                    tooltip: tooltip

                });
                //1DE9B6
                this.transformData((result) => {

                    dt = result.map((item) => {
                        return {
                            "geometry": {
                                "type": "Point",
                                "coordinates": [item.lng, item.lat]
                            },
                            name: item['小区名称'],
                            _data: {
                                ...item
                            },
                            "count": item['数量']
                        }
                    });
                    const makeData = dt.filter((item, index) => {
                        return item._data['状态'] == 1;
                    });
                    const suspectData = dt.filter((item, index) => {
                        return item._data['状态'] == 2;
                    });
                    const normalData = dt.filter((item, index) => {
                        return item._data['状态'] == 3;
                    });
                    makeScatter.setValue(makeData);
                    suspectScatter.setValue(suspectData);
                    normalScatter.setValue(normalData);

                    mapComponent.setEchartLayers([makeScatter, suspectScatter, normalScatter]);
                    const myChart = mapComponent.getEcharts();
                    if (this.isEditing) { //编辑状态取消轮询
                        return;
                    }

                    //轮询
                    if (this.timer) {
                        clearTimeout(this.timer);
                    }
                    const len = dt.length;
                    let index = 0;

                    const loopDisPatch = () => {
                        myChart.dispatchAction({
                            type: 'showTip',
                            seriesIndex: index,
                            dataIndex: 0

                        });
                        myChart.dispatchAction({
                            type: 'highlight',
                            seriesIndex: index,
                            dataIndex: 0

                        });

                        myChart.dispatchAction({
                            type: 'downplay',
                            seriesIndex: index - 1 < 0 ? len - 1 : index - 1,
                            dataIndex: 0
                        })


                        index++;
                        if (index > len - 1) {
                            index = 0;
                        }
                        this.timer = setTimeout(loopDisPatch, 3000);
                    }
                    this.timer = setTimeout(loopDisPatch, 3000);

                    this.$el.addEventListener('mouseout', () => {
                        if (this.timer) {
                            clearTimeout(this.timer);

                            myChart.dispatchAction({
                                type: 'downplay',
                                seriesIndex: index - 1 < 0 ? len - 1 : index - 1,
                                dataIndex: 0
                            })
                        }
                        this.timer = setTimeout(loopDisPatch, 3000);
                    });
                    this.$el.addEventListener('mouseover', () => {
                        myChart.dispatchAction({
                            type: 'downplay',
                            seriesIndex: index - 1 < 0 ? len - 1 : index - 1,
                            dataIndex: 0
                        })
                        if (this.timer) {
                            clearTimeout(this.timer);
                        }
                    });

                });
            },

            geogetPoint(myGeo, address, cityName, item) {
                return new Promise((resolve, reject) => {
                    myGeo.getPoint(address, function (point) {
                        if (point) {
                            resolve({
                                ...point,
                                ...item
                            });
                        } else {
                            reject(address, cityName)
                        }
                    }, cityName);
                });
            },
            transformData(callback) {
                const myGeo = new window.BMap.Geocoder();
                const pointAsync = [];
                this.dataJSON.forEach((item) => {
                    if (item['城市'] && item['所属区县'] && item['小区名称']) {
                        pointAsync.push(this.geogetPoint(myGeo, `${item['城市']}${item['所属区县']}${item['小区名称']}`,
                            '北京市', item));
                    }
                });
                Promise.all(pointAsync).then((result) => {
                    callback(result);
                    // console.log(result, '====');
                }).catch((e) => {
                    console.log(e, '====');
                });

            },
            resize() {
                this.$refs.map.resize();
            }

        },
        mounted() {

        }
    }
</script>